//*** Lib */
import { axiosGetUserDetailsAuthorize, axiosPost, axiosPostSSO } from '../AxiosRequests';
import { AdminLogin, ValidateToken , ProjectAuthentication, GetUserDetailsByClientIdAndSecretkey} from '../ApiEndPoints';

export default class AuthenticationServices {

    // API function
    async adminLogin(request) {
        return axiosPost(AdminLogin, request);
    }

}